import React from 'react';
import styled from '@emotion/styled';

const Root = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.spacing(7, 0)};

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    padding: ${theme.spacing(11, 0)};
  `}
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.neutrals.grey8};
`;

export const Divider: React.FC = () => {
  return (
    <Root>
      <Line />
    </Root>
  );
};
